import "core-js/modules/es.regexp.exec.js";
import { showDialog, showToast, Tabbar, TabbarItem, Tag } from 'vant';
import Navbar from '@/components/Navbar.vue';
import EventsBlock from '@/components/EventsBlock.vue';
import ShareIos from '@/icons/ShareIos.vue';
import AddIos from '@/icons/AddIos.vue';
export default {
  name: 'App',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tag.name]: Tag,
    Navbar,
    EventsBlock,
    ShareIos,
    AddIos
  },

  data() {
    var _navigator, _navigator$userAgent;

    let dayjs = require('dayjs');

    return {
      events: require(`@/data/${this.$root.server}/events.json`),
      tools: [[{
        background: 'linear-gradient(135deg, #91c4cc, #b7ddc0)',
        to: '/gacha'
      }, {
        background: 'linear-gradient(135deg, #6c71c5, #93a9da)',
        to: '/wishsim'
      }], [{
        background: 'linear-gradient(135deg, #bbe0f5, #e0f8e0)',
        color: 'rgba(69, 90, 100, .8)',
        to: '/hoard'
      }, {
        background: 'linear-gradient(135deg, #fbe9c3, #e6d8be)',
        color: 'rgba(85, 76, 60, .8)',
        to: '/cpr'
      }, {
        background: 'linear-gradient(135deg, #fbe4e2, #f3b0a6)',
        color: 'rgba(109, 46, 43, 0.8)',
        to: '/level'
      }, {
        background: 'linear-gradient(135deg, #f3d7d3, #c4c7e8)',
        color: 'rgba(78, 68, 91, 0.8)',
        to: '/item'
      }], [{
        background: 'linear-gradient(135deg, #6c71c5, #93a9da)',
        to: '/wish'
      }], [{
        background: 'linear-gradient(135deg, #91c4cc, #b7ddc0)',
        to: '/image'
      }]],
      mirrors: [{
        name: 'GitHub Pages',
        hostname: 'waterv.github.io',
        url: 'https://waterv.github.io/lightandnight'
      }, {
        name: 'Vercel',
        hostname: 'lightandnight.vercel.app',
        url: 'https://lightandnight.vercel.app'
      }],
      langs: [{
        text: '简体中文',
        value: 'zh-CN'
      }],
      servers: [{
        text: 'CN',
        value: 'CN'
      }],
      langName_: undefined,
      showLangPicker: false,
      showServerPicker: false,
      showAddToHome: false,
      isIos: Number(!!((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator$userAgent = _navigator.userAgent) !== null && _navigator$userAgent !== void 0 && _navigator$userAgent.match(/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i))),
      // Copied from faisalman/ua-parser-js
      active: this.$root.homepageActive,
      hostname: window.location.hostname,
      version: dayjs(require('@/data/app/time.json').time).format('YYYY-MM-DD HH:mm:ss')
    };
  },

  computed: {
    appearance: {
      get() {
        return this.$root.theme == 'dark';
      },

      set(v) {
        this.$root.theme = v ? 'dark' : '';
      }

    },
    lang: {
      get() {
        var _localStorage;

        return ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem('lang')) || 'zh-CN';
      },

      set(v) {
        var _localStorage2;

        (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem('lang', v);
        this.$i18n.locale = v;
      }

    },
    langName: {
      get() {
        var _localStorage3;

        return this.langName_ || ((_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.getItem('langName')) || '简体中文';
      },

      set(v) {
        var _localStorage4;

        this.langName_ = v;
        (_localStorage4 = localStorage) === null || _localStorage4 === void 0 ? void 0 : _localStorage4.setItem('langName', v);
      }

    },

    fill() {
      return this.$root.theme == 'dark' ? 'rgba(255, 255, 255, 0.75)' : '#323233';
    }

  },

  mounted() {
    var _localStorage5;

    let userVersion = Number(((_localStorage5 = localStorage) === null || _localStorage5 === void 0 ? void 0 : _localStorage5.getItem('version')) || 0);

    let {
      version,
      title,
      message
    } = require('@/data/app/announce.json');

    if (userVersion < version && message) {
      showDialog({ ...this.$root.dialogSettings,
        title: title || this.$t('common.announce'),
        message,
        confirmButtonText: this.$t('common.announceNoMore')
      }).then(() => {
        var _localStorage6;

        (_localStorage6 = localStorage) === null || _localStorage6 === void 0 ? void 0 : _localStorage6.setItem('version', version);
      });
    }
  },

  methods: {
    onActiveChange(active) {
      this.$root.homepageActive = active;
    },

    clearLocalStorage() {
      var _localStorage7;

      (_localStorage7 = localStorage) === null || _localStorage7 === void 0 ? void 0 : _localStorage7.clear();
      showToast({
        message: this.$t('settings.clearLocalStorageToast'),
        icon: 'passed'
      });
    },

    onLangConfirm({
      selectedOptions
    }) {
      this.showLangPicker = false;
      this.langName = selectedOptions[0].text;
      this.lang = selectedOptions[0].value;
    },

    onServerConfirm({
      selectedOptions
    }) {
      this.showServerPicker = false;
      this.$root.server = selectedOptions[0].value;
    }

  }
};